import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StorageTimerBaseComponent } from '@luggagehero/features/bookings';

@Component({
  selector: 'lh-storage-timer',
  templateUrl: './storage-timer.component.html',
  styleUrls: ['./storage-timer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StorageTimerComponent extends StorageTimerBaseComponent {}
